import * as THREE from 'three';
import Experience from '../Experience.js';
import Camera from '../Camera.js'

let vindu,envmap = null


export default class Blokk {
    constructor() {
        this.experience = new Experience();
        this.camera = this.experience
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.instance = this.camera.instance
        this.renderer = this.experience.renderer;

        this.resource = this.resources.items.blokk;
        this.model = null;
        this.envmaploader = new THREE.PMREMGenerator(this.renderer.instance);
        this.resourceHdr = this.resources.items.refleksjon;
            envmap = this.envmaploader.fromCubemap(this.resourceHdr);
            vindu = new THREE.MeshPhysicalMaterial({
            roughness: 0,
            metalness: 0.5,
            transparent: true,
            transmission: 0.8,
            // envMap: envmap.texture,
        });

        this.setModel();  
    }

    setModel() {

        this.model = this.resource.scene 
        // console.log(this.model)
        this.model.traverse((child) =>{
            if(child instanceof THREE.Mesh){
                child.castShadow = true
                child.receiveShadow = true;
                
                    
                if (child.material.name === "[Translucent Glass Sky Reflection]") {
                    child.material = vindu;
                  }
                if (child.material.name === "innetak") {
                    child.material.transparent = true
                    child.material.opacity = 0.75
                    child.material.depthWrite = false
                  }
                }
        })
        this.scene.add(this.model)
        
    }

    update() {
        // Update logic if needed
    }
}